module.exports = __webpack_public_path__ + "static/media/image7.c681e512.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ClickImage/images/image7.jpg
// module id = 41
// module chunks = 0